import HTMLReactParser from 'html-react-parser';
import { resolveImageReferenceToImage } from '../../../../cms/resolvers/imageResolver';
import type { ImageProps } from '2-core-elements/Image/Image';
import type { BadgeProps } from '3-components/Chip/Chip';
import type { EventsCardProps } from './eventsListingResolver';

export type EventPages = {
    title?: string;
    summary?: string;
    type?: string;
    topic?: string[];
    category?: string[];
    image?: {
        url: string;
        altText: string;
    };
    location: string;
    startDate?: string;
    endDate?: string;
    url?: string;
    time?: string;
}

export const resolveEventPagesToArticleCards = (items: EventPages[]): EventsCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const {
            title,
            summary,
            type,
            image,
            topic,
            category,
            location,
            startDate,
            endDate,
            url,
            time,
        } = item as NonNullable<typeof item>;
        const tags = [{ label: type, skin: 'primary' }] as BadgeProps[];
        const img = resolveImageReferenceToImage(`${image?.url}`) as ImageProps;

        return {
            ...(url && { link: { href: url } }),
            title: title as string,
            ...(summary && { summary: HTMLReactParser(summary as string) }),
            tags,
            img,
            type,
            topic,
            category,
            startDate,
            endDate,
            location,
            time,
        };
    });
};
